import Modal from '../../../../../../component/modal/Modal';
import Button from '../../../../../../component/ui/Button';
import { usageOverviewStatusColor, usageOverviewStatusText } from '../../../../../../utils/utility';

export default function UsageOverviewModal({
  isOpenModal,
  setIsOpenModal,
  data,
  planType,
  setIsOpenUpgradeModal
}) {

  const headers = [
    { label: 'FEATURE', width: '40%' },
    { label: 'USAGE', width: '15%' },
    { label: 'PROGRESS', width: '30%' },
    { label: 'STATUS', width: '15%', className: 'text-end' }
  ];

  return (
    <Modal
      className="subscription-modal"
      title={"Usage Overview"}
      badge={planType || 'Free Plan'}
      subtitle={'Showing usage for your current billing period'}
      isOpen={isOpenModal}
      onClose={() => {
        setIsOpenModal(false);
      }}
      cancelButton={() => {
        setIsOpenModal(false);
      }}
      bodyClassName="d-flex flex-column overflow-hidden"
    >
      {data && <div className="overflow-auto rounded-4 border" style={{ maxHeight: '380px' }}>
        <table className="currency-table">
          <thead className="bg-light">
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  style={{ width: header.width }}
                  className={header.className || ''}
                >
                  {header.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data && Object.entries(data).map(([key, item]) => {
              return (
                <tr key={key}>
                  <td className='fs-5 fw-light'>{`${item.name}`}
                  </td>
                  <td className="fs-5 fw-semibold">
                    {item.total_consumed} / {item.total}
                  </td>

                  <td>
                    <div
                      className="progress"
                      style={{
                        height: "6px",
                        borderRadius: "10px",
                      }}
                    >
                      <div
                        className={`progress-bar ${usageOverviewStatusColor(item.usage_percentage).bg}`}
                        style={{
                          width: `${item.usage_percentage}%`,
                        }}
                      />
                    </div>
                  </td>

                  <td className="text-end">
                    <span
                      className={`fs-6 badge rounded-pill px-3 py-2 
                        ${usageOverviewStatusColor(item.usage_percentage).bg} ${usageOverviewStatusColor(item.usage_percentage).text} ${usageOverviewStatusColor(item.usage_percentage).badge}`}
                    >
                      {usageOverviewStatusText(item.usage_percentage)}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>}

      <div className="d-flex justify-content-end align-items-center gap-4 mt-4">
        <Button
          type="button"
          className="mt-0 border-primary btn-primary rounded-4 fs-5 fw-light add-pro py-3 px-5 "
          button="Upgrade Plan"
          onClick={() => {
            setIsOpenModal(false);
            setIsOpenUpgradeModal(true)
          }}
        />
        <Button
          type="button"
          className="mt-0 btn-gray rounded-4 text-dark fs-5 fw-light add-pro px-5"
          button="Cancel"
          onClick={() => setIsOpenModal(false)}
        />
      </div>
    </Modal>
  );
}